// extracted by mini-css-extract-plugin
module.exports = {"AIModel":"AIModel--2zx4Q"};